import { makeStyles } from '@mui/styles'
import FooterLogo from 'components/footer-logo'
import Header from 'components/header'
import Page from 'components/page'
import { PropsWithChildren } from 'react'

const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-between',
    overflowY: 'auto',
    width: '100%',
    minHeight: '100vh',
  },
})

const WrapperWithHeader = ({ children }: PropsWithChildren) => {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <Header />
      <Page>{children}</Page>
      <FooterLogo />
    </div>
  )
}

export default WrapperWithHeader
